import { Link2 } from "lucide-react";
import { findJoints, JOINT_LABEL } from "@/lib/joints";
import { getUserDetails } from "@/lib/details";

export const JointsBox = ({ item, update }) => {
  const joints = findJoints(item);
  if (!joints.length) return null;
  const details = getUserDetails();
  const set = (j, v) => update({ ...item, joints: { ...(item.joints || {}), [j.key]: v } });
  return (
    <div className="rounded-md border border-cyan-500/30 bg-cyan-500/5 p-3 space-y-2" data-testid="joints-box">
      <p className="font-mono text-[10px] uppercase tracking-wider text-cyan-200 flex items-center gap-1.5"><Link2 size={12} />Combination joints · sliding meets other units</p>
      {joints.map((j) => {
        const cat = details.find((d) => d.joint === j.type) || details.find((d) => d.joint === "coupling");
        return (
          <div key={j.key} className="rounded border border-slate-700 p-2 space-y-1.5" data-testid={`joint-${j.mark.toLowerCase()}`}>
            <div className="flex items-center gap-2">
              <span className="font-mono text-xs font-bold text-amber-300">{j.mark}</span>
              <span className="text-xs text-slate-200 flex-1">{JOINT_LABEL[j.type] || j.type} · {j.orientation === "v" ? "vertical" : "horizontal"} · {j.length} mm</span>
            </div>
            <div className="grid grid-cols-2 h-7 rounded-md border border-slate-700 overflow-hidden">
              <button data-testid={`joint-${j.mark.toLowerCase()}-coupled`} onClick={() => set(j, true)}
                className={`text-[10px] transition-colors ${j.coupled ? "bg-cyan-500 text-slate-950" : "text-slate-400 hover:bg-slate-800"}`}>Coupled units</button>
              <button data-testid={`joint-${j.mark.toLowerCase()}-same`} onClick={() => set(j, false)}
                className={`text-[10px] transition-colors ${!j.coupled ? "bg-cyan-500 text-slate-950" : "text-slate-400 hover:bg-slate-800"}`}>Same frame (fixed shutter)</button>
            </div>
            {j.coupled && (
              <p className="text-[10px] text-slate-400" data-testid={`joint-${j.mark.toLowerCase()}-detail`}>
                {cat ? `Catalogue coupling detail: ${cat.title} (p.${cat.page})` : "No coupling detail in your catalogues — a coupling section is generated from both systems' frames. Add the exact detail in Catalogue › Add detail."}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};
